import { Link } from "react-router-dom";
import { Bookmark, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { PlanetOrb } from "./PlanetOrb";
import { RarityBadge, BiomeBadge, HazardMeter } from "./Badges";

export const PlanetCard = ({ planet, onSave, index = 0, showOwner = false }) => (
  <motion.article
    initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: Math.min(index, 8) * 0.05, duration: 0.4 }}
    className="glass hud-corners card-hover rounded-xl p-5 flex flex-col gap-4" data-testid="planet-card">
    <div className="flex items-start gap-4">
      <Link to={`/planet/${planet.id}`} className="shrink-0 w-24 sm:w-28" data-testid="planet-card-orb-link">
        <PlanetOrb planet={planet} glow={false} />
      </Link>
      <div className="min-w-0 flex-1">
        <p className="font-mono text-[0.62rem] tracking-[0.25em] text-cyan-400/80 uppercase">{planet.star_code}</p>
        <Link to={`/planet/${planet.id}`} data-testid="planet-card-name-link">
          <h3 className="font-display text-lg sm:text-xl font-semibold tracking-wide text-slate-50 truncate hover:text-cyan-200 transition-colors" data-testid="planet-card-name">
            {planet.name}
          </h3>
        </Link>
        <p className="text-sm text-slate-400 line-clamp-2 mt-1">{planet.tagline}</p>
        {showOwner && <p className="label-mono mt-2">by {planet.owner_name}</p>}
      </div>
    </div>
    <div className="flex flex-wrap gap-2">
      <BiomeBadge biome={planet.biome} />
      <RarityBadge rarity={planet.rarity} />
    </div>
    <div className="flex items-center justify-between gap-3 pt-1 border-t border-white/5">
      <HazardMeter level={planet.hazard_level} compact />
      <div className="flex items-center gap-2">
        {onSave && (
          <button onClick={() => onSave(planet)} className={`btn-ghost !px-3 !py-1.5 ${planet.saved ? "active" : ""}`}
            data-testid="planet-card-save-button" title={planet.saved ? "Remove from library" : "Save to library"}>
            <Bookmark className={`h-3.5 w-3.5 ${planet.saved ? "fill-cyan-300" : ""}`} />
          </button>
        )}
        <Link to={`/planet/${planet.id}`} className="btn-ghost !px-3 !py-1.5" data-testid="planet-card-enter-button">
          Enter <ArrowUpRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  </motion.article>
);
